import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OauthAEMConfig, UserSessionService } from '@com-delta-idp/mnx-oauth';
import { LogoutService } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { CookieHelperService } from '@com-delta-idp/mnx-utils';
import { CoreUtilService } from '../../utils/core-util.service';
import { LoginAuthenticationHelperService } from '../../utils/login-authentication-helper.service';
import { LoginHelperUtils } from '../../utils/login-helper.utils';
import { MfaUtilService } from '../../utils/mfa-util.service';
import { NuTravelSkybonusUtilService } from '../../utils/nuTravelSkyBonusUtils/nu-travel-skybonus-util.service';
import {
  CANCEL_TRIP_CONFIRMATION_REDIRECTION,
  HOME_PAGE_URL,
  MY_TRIPS_REDIRECTION,
  REDIRECT_BACK
} from '../constants/login-constant';
import { AddSqaFacadeService } from '../facade/add-sqa/add-sqa-facade.service';
import { loginAndGetDashboardResponse } from '../models/login-authentication-screen.interface';
import { NextDisplayViewService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class PingLoginAdapterExtendedSupportService {
  refreshUrl!: string | undefined;
  fromApplication: string | undefined;
  redirectUrl: string | undefined;
  nuTravelSkyBonusUtilService = inject(NuTravelSkybonusUtilService);
  coreUtilService = inject(CoreUtilService);
  router = inject(Router);
  loginUtilHelperService = inject(LoginHelperUtils);
  loginAuthenticationHelperService = inject(LoginAuthenticationHelperService);
  cookieHelper = inject(CookieHelperService);
  logOutService = inject(LogoutService);
  nextDisplayService = inject(NextDisplayViewService);
  addSqaFacadeService = inject(AddSqaFacadeService);
  mfaUtilService = inject(MfaUtilService);
  route = inject(ActivatedRoute);
  userService = inject(UserSessionService);

  updateRefreshURL(refreshURL: string | undefined) {
    let searchParam = window.location.search;
    const aemrefreshurl = <HTMLInputElement>(
      document.querySelector('#aemrefreshurl')
    );
    if (this.coreUtilService.updateRefreshUrlCheck(aemrefreshurl)) {
      if (aemrefreshurl) {
        if (searchParam === '') {
          searchParam = '?staticurl=t';
        } else {
          searchParam = searchParam + '&staticurl=t';
        }
        this.refreshUrl =
          window.location.pathname.replace(/\/$/, '') + searchParam;
      } else {
        this.refreshUrl = refreshURL;
      }
    } else {
      this.refreshUrl = refreshURL;
    }
  }

  returnToOriginalUrl(
    resUrl: loginAndGetDashboardResponse,
    authenticationConfig?: OauthAEMConfig
  ) {
    const bauUrls = authenticationConfig?.BAU_URLS ?? [];
    return bauUrls.some((item) => resUrl?.refreshURL?.includes(item)) ?? false;
  }

  routeBasedOnCondition(routePath: string) {
    window.location.assign(routePath);
  }

  checkForCancelConfirmationUrl() {
    this.refreshUrl = this.refreshUrl?.includes(
      CANCEL_TRIP_CONFIRMATION_REDIRECTION
    )
      ? MY_TRIPS_REDIRECTION
      : this.refreshUrl;
  }

  redirectToRefreshUrl(
    standalonePage: boolean,
    response: loginAndGetDashboardResponse,
    authenticationConfig?: OauthAEMConfig,
    tokenResponse?: string
  ) {
    if (
      this.redirectToRefreshUrlCheck(
        standalonePage,
        response,
        authenticationConfig
      )
    ) {
      (
        document.getElementById(
          'loginStandaloneRedirectForm'
        ) as HTMLFormElement
      ).submit();
    } else if (
      standalonePage &&
      !this.returnToOriginalUrl(response, authenticationConfig)
    ) {
      this.checkRedirectBack(response);
    } else {
      this.updateRefreshURL(response?.refreshURL);
    }
    return this.nuTravelSkyBonusUtilService.redirectUserToRefreshUrl(
      this.fromApplication,
      this.redirectUrl,
      this.refreshUrl,
      authenticationConfig,
      response,
      tokenResponse
    );
  }

  checkRedirectBack(response: loginAndGetDashboardResponse) {
    if (this.route.snapshot.queryParamMap.get(REDIRECT_BACK)) {
      this.refreshUrl = document.referrer;
    } else {
      this.refreshUrl = response?.refreshURL ?? HOME_PAGE_URL;
    }
  }

  redirectToRefreshUrlCheck(
    standalonePage: boolean,
    response: loginAndGetDashboardResponse,
    authenticationConfig?: OauthAEMConfig
  ) {
    return (
      standalonePage && this.returnToOriginalUrl(response, authenticationConfig)
    );
  }
}
